import axios from 'axios'
import Utils from '../services/Utils'

axios.defaults.timeout = 900000
axios.defaults.urls = JSON.parse(process.env.VUE_APP_URL)
axios.defaults.ptApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].base
axios.defaults.chatApiUrl = window.isPT ? axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].dashboardChatApi : axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].appChatApi
axios.defaults.storageApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].storage


export default {
    pt: {
        getStrings(callback) {
            if (window.appCache && window.appCache.strings) {
                return Utils.processResponse({
                    request: {
                        response: JSON.stringify({
                            success: true,
                            data: window.appCache.strings
                        })
                    }
                }, callback)
            }
            axios.get(axios.defaults.ptApiUrl + 'translations?lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        getEnums(callback) {
            if (window.appCache && window.appCache.enums) {
                Utils.refreshEnums(window.appCache.enums)
                return callback()
            }
            if (!window.isPT) {
                return callback()
            }
            axios.get(axios.defaults.ptApiUrl + 'enums?pt_id=' + window.chatUserPtId, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                let enums = {}
                if (response.data && response.data.data) {
                    enums = response.data.data
                }
                Utils.refreshEnums(enums)
                callback()
            }).catch(() => {
                Utils.refreshEnums({})
                callback()
            })
        },
        getUser(id, callback) {
            const fields = ['pt_id', 'id', 'chat_id', 'chat_token', 'name', 'email', 'password', 'notes']
            if (window.appCache && window.appCache.user && window.appCache.user.db_id === id) {
                let hasValues = true
                fields.forEach(function (fd) {
                    if (!window.appCache.user[fd]) {
                        hasValues = false
                    }
                })
                if (hasValues) {
                    return Utils.processResponse({
                        request: {
                            response: JSON.stringify({
                                success: true,
                                data: [window.appCache.user]
                            })
                        }
                    }, callback)
                }
            }
            axios.get(axios.defaults.ptApiUrl + 'user?filter={"db_id":' + id + '}&fields=' + JSON.stringify(fields) + '&photo=0&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        getUserByChatId(data, callback) {
            axios.get(axios.defaults.ptApiUrl + 'user?filter={"pt_id":' + data.ptId + ', "chat_id":' + data.chatId + '}' + (data.fields ? ('&fields=' + JSON.stringify(data.fields)) : '') + (data.updateFlags ? '&update_flags=1' : '') + '&photo=0&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        updateUser(data, callback) {
            const id = data.id
            delete data.id
            const chatId = data.chat_id
            const ptId = data.pt_id
            delete data.pt_id
            axios.patch(axios.defaults.ptApiUrl + 'user?' + (id ? 'id=' + id : '') + '' + (chatId && !id ? 'chat_id=' + chatId : '') + '&pt_id=' + ptId + '&lng=' + window.language,
                data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt')
                }
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        getPtClients(data, callback) {
            const ptId = window.ptUserId ? window.ptUserId : window.chatUserPtId
            axios.get(axios.defaults.ptApiUrl + 'user?filter={"pt_id":' + ptId + ',"type":1,"status":0}&order={"id":0}&photo=0&fields=' + JSON.stringify(data.fields) + '&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        decryptPassword(password, callback) {
            axios.post(axios.defaults.ptApiUrl + 'pwd_dec?lng=' + window.language, {
                password: password,
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        getClientRegister(id, callback) {
            const ptId = window.ptUserId ? window.ptUserId : window.chatUserPtId
            axios.get(axios.defaults.ptApiUrl + 'register?filter={"pt_id": ' + ptId + ', "id": ' + id + '}&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        updateClientRegister(data, callback) {
            const ptId = window.ptUserId ? window.ptUserId : window.chatUserPtId
            const id = data.id
            delete data.id

            axios.patch(axios.defaults.ptApiUrl + 'register?id=' + id + '&pt_id=' + ptId + '&lng=' + window.language,
                data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        getFoods(callback) {
            const ptId = window.ptUserId ? window.ptUserId : window.chatUserPtId
            axios.get(axios.defaults.ptApiUrl + 'food?db_id=' + ptId + '&fields=["id","name"]&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        newCalendarItem(data, callback) {
            data.pt_id = window.ptUserId ? window.ptUserId : window.chatUserPtId
            axios.post(axios.defaults.ptApiUrl + 'calendar/item?lng=' + window.language,
                data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        getLastPhysicalEvaluation(data, callback) {
            axios.get(axios.defaults.ptApiUrl + 'physical_evaluation?db_id=' + data.id + '&fields=' + (data.fields ? (JSON.stringify(data.fields)) : '["id","notes"]') + '&order={"id":1}&limit=1&website=1&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        updatePhysicalEvaluation(data, callback) {
            const userId = data.client_id
            delete data.client_id
            const id = data.id
            delete data.id
            axios.patch(axios.defaults.ptApiUrl + 'physical_evaluation?db_id=' + userId + '&id=' + id + '&website=1&lng=' + window.language,
                data, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('pt'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
    },
    chat: {
        // User
        newUser(data, callback) {
            Utils.validateChatToken(function () {
                axios.post(axios.defaults.chatApiUrl + 'user?lng=' + window.language,
                    data, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    }
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        getUser(id, callback) {
            Utils.validateChatToken(function () {
                axios.get(axios.defaults.chatApiUrl + 'user?filter={"id":' + id + '}&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        getUserByEmail(email, callback) {
            Utils.validateChatToken(function () {
                axios.get(axios.defaults.chatApiUrl + 'user?filter={"email":"' + email + '"}&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        deleteUser(data, callback) {
            Utils.validateChatToken(function () {
                const employeeId = window.logId ? Math.abs(window.logId) : Math.abs(window.chatUserPtId)
                axios.delete(axios.defaults.chatApiUrl + 'user?id=' + data.id + '&employee_id=' + employeeId + '&employee_pt_id=' + window.chatUserPtId + (data.client_id ? ('&client_id=' + data.client_id) : '') + '&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },

        // Chat
        newChat(data, callback) {
            Utils.validateChatToken(function () {
                axios.post(axios.defaults.chatApiUrl + 'chat?lng=' + window.language,
                    data, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    }
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        updateChat(data, callback) {
            Utils.validateChatToken(function () {
                const id = data.id
                delete data.id
                axios.patch(axios.defaults.chatApiUrl + 'chat?id=' + id + '&lng=' + window.language,
                    data, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    }
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        deleteChat(data, callback) {
            Utils.validateChatToken(function () {
                const employeeId = window.logId ? Math.abs(window.logId) : Math.abs(window.chatUserPtId)
                axios.delete(axios.defaults.chatApiUrl + 'chat?id=' + data.id + '&employee_id=' + employeeId + '&employee_pt_id=' + window.chatUserPtId + (data.client_id ? ('&client_id=' + data.client_id) : '') + '&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        getChats(data, callback) {
            Utils.validateChatToken(function () {
                axios.get(axios.defaults.chatApiUrl + 'chat?user_id=' + data.id + '&users=true' + (!data.expanded ? '&compress=1' : '') + (data.months ? ('&months=' + data.months) : '') + '&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                    responseType: !data.expanded ? 'arraybuffer' : null,
                }).then((response) => {
                    Utils.processResponse(response, function (resp) {
                        try {
                            if (resp && resp.success && resp.data) {
                                for (const item of resp.data) {
                                    if (typeof item.users === 'string') {
                                        item.users = JSON.parse(item.users)
                                    }
                                }
                                if (data.pt_chat_id) {
                                    resp.data = resp.data.filter(function (item) {
                                        return item.users.indexOf(data.pt_chat_id) > -1
                                    })
                                }
                            }
                        } catch (error) { }
                        callback(resp)
                    })
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        getChatsNames(data, callback) {
            Utils.validateChatToken(function () {
                axios.get(axios.defaults.chatApiUrl + 'chat?search={"id":' + JSON.stringify(data.ids) + '}&fields=["id","name"]&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        getChatsDraftsAndOpenedFlag(data, callback) {
            Utils.validateChatToken(function () {
                axios.get(axios.defaults.chatApiUrl + 'chat?user_id=' + data.id + '&fields=["id","draft","opened"]&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },

        // Message
        newMessage(data, callback) {
            Utils.validateChatToken(function () {
                if (window.chatUserPtId && data) {
                    data.employee_pt_id = window.chatUserPtId
                    if (window.isPT) {
                        if (window.logId) {
                            data.employee_id = Math.abs(window.logId)
                        } else {
                            data.employee_id = Math.abs(window.chatUserPtId)
                        }
                    }
                }
                axios.post(axios.defaults.chatApiUrl + 'message?lng=' + window.language,
                    data, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    }
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        newMessages(data, callback) {
            Utils.validateChatToken(function () {
                if (window.chatUserPtId && data) {
                    for (let i = 0; i < data.length; i++) {
                        data[i].employee_pt_id = window.chatUserPtId
                        if (window.isPT) {
                            if (window.logId) {
                                data[i].employee_id = Math.abs(window.logId)
                            } else {
                                data[i].employee_id = Math.abs(window.chatUserPtId)
                            }
                        }
                    }
                }
                axios.post(axios.defaults.chatApiUrl + 'message?array=true&lng=' + window.language,
                    data, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    }
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        updateMessage(data, callback) {
            Utils.validateChatToken(function () {
                const id = data.id
                delete data.id
                const chatId = data.chat_id
                delete data.chat_id
                if (window.chatUserPtId && data) {
                    data.employee_pt_id = window.chatUserPtId
                    if (window.isPT) {
                        if (window.logId) {
                            data.employee_id = Math.abs(window.logId)
                        } else {
                            data.employee_id = Math.abs(window.chatUserPtId)
                        }
                    }
                }
                axios.patch(axios.defaults.chatApiUrl + 'message?id=' + id + '&chat_id=' + chatId + '&lng=' + window.language,
                    data, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    }
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        deleteMessage(data, callback) {
            Utils.validateChatToken(function () {
                const id = data.id
                delete data.id
                const chatId = data.chat_id
                delete data.chat_id
                axios.delete(axios.defaults.chatApiUrl + 'message?id=' + id + '&chat_id=' + chatId + '&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        getMessage(data, callback) {
            Utils.validateChatToken(function () {
                axios.get(axios.defaults.chatApiUrl + 'message?user_id=' + data.user_id + '&filter={"chat_id":' + data.chat_id + ',"id":' + data.id + '}&read=' + (data.read && !window.chatDisabled ? 'true' : 'false') + '&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        getFixedMessages(data, callback) {
            Utils.validateChatToken(function () {
                const fields = data.fields ? JSON.stringify(data.fields) : '["id","chat_id","user_id","date_utc","type","message","status","message_aux","pinned"]'
                axios.get(axios.defaults.chatApiUrl + 'message?user_id=' + data.user_id + '&filter={"chat_id":' + data.chat_id + ',"pinned":1}&fields=' + fields + '&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        getMessages(data, callback) {
            Utils.validateChatToken(function () {
                const fields = '&fields=["id","chat_id","user_id","date_utc","type","message","status","message_aux","pinned"]'
                const readValue = !window.chatDisabled ? true : false

                // Obter as mensagens ao abrir o chat (não tem ainda nenhum message id)
                if (!data.message_id) {
                    return axios.get(axios.defaults.chatApiUrl + 'message?user_id=' + data.user_id + '&filter={"chat_id":' + data.chat_id + '}&order={"id":1}&limit=' + data.limit + fields + '&read=' + readValue + '&lng=' + window.language, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: axios.defaults.chatAuthorizationToken,
                        },
                    }).then((response) => {
                        Utils.processResponse(response, callback)
                    }).catch((response) => {
                        Utils.processResponse(response, callback)
                    })
                }

                // Obter últimas mensagens (mensagens novas)
                if (data.new_messages) {
                    return axios.get(axios.defaults.chatApiUrl + 'message?user_id=' + data.user_id + '&query=[{"f":"chat_id","q":0,"v":' + data.chat_id + ',"n":1},{"f":"id","q":' + (data.include_message_id ? 5 : 3) + ',"v":' + data.message_id + '}]&limit=' + data.limit + fields + '&read=' + readValue + '&lng=' + window.language, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: axios.defaults.chatAuthorizationToken,
                        },
                    }).then((response) => {
                        Utils.processResponse(response, callback)
                    }).catch((response) => {
                        Utils.processResponse(response, callback)
                    })
                }

                // Obter mensagens antigas (scroll para cima)
                if (!data.new_messages) {
                    return axios.get(axios.defaults.chatApiUrl + 'message?user_id=' + data.user_id + '&query=[{"f":"chat_id","q":0,"v":' + data.chat_id + ',"n":1},{"f":"id","q":2,"v":' + data.message_id + '}]&limit=' + data.limit + fields + '&order={"id":1}&read=' + readValue + '&lng=' + window.language, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: axios.defaults.chatAuthorizationToken,
                        },
                    }).then((response) => {
                        Utils.processResponse(response, callback)
                    }).catch((response) => {
                        Utils.processResponse(response, callback)
                    })
                }
            })
        },
        getImagesMessages(data, callback) {
            Utils.validateChatToken(function () {
                const query = data.message_id ? 'query=[{"f":"chat_id","q":0,"v":' + data.chat_id + ',"n":1},{"f":"type","q":0,"v":1,"n":1},{"f":"id","q":2,"v":' + data.message_id + '}]' : 'query=[{"f":"chat_id","q":0,"v":' + data.chat_id + ',"n":1},{"f":"type","q":0,"v":1,"n":0}]'
                axios.get(axios.defaults.chatApiUrl + 'message?user_id=' + data.user_id + '&' + query + '&limit=10&order={"id":1}&read=false&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },

        // New messages count
        getNewMessagesCount(id, callback) {
            Utils.validateChatToken(function () {
                axios.get(axios.defaults.chatApiUrl + 'message/count?user_id=' + id + '&details=true&compress=1&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    },
                    responseType: 'arraybuffer',
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },

        // Page employee
        getPagesEmployees(callback) {
            Utils.validateChatToken(function () {
                axios.get(axios.defaults.chatApiUrl + 'page?lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    }
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        updatePageEmployee(data, callback) {
            Utils.validateChatToken(function () {
                axios.post(axios.defaults.chatApiUrl + 'page?lng=' + window.language,
                    data, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    }
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },

        // IA
        getIASummary(id, callback) {
            Utils.validateChatToken(function () {
                axios.get(axios.defaults.chatApiUrl + 'ia/chat/summary?id=' + id + '&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    }
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
        getRoomNotes(id, callback) {
            Utils.validateChatToken(function () {
                axios.get(axios.defaults.chatApiUrl + 'notes?filter={"chat_id":' + id + '}&order={"day":1}&limit=10&lng=' + window.language, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: axios.defaults.chatAuthorizationToken,
                    }
                }).then((response) => {
                    Utils.processResponse(response, callback)
                }).catch((response) => {
                    Utils.processResponse(response, callback)
                })
            })
        },
    },
    storage: {
        sendFile(data, callback) {
            axios.post(axios.defaults.storageApiUrl + 'file?base64=true' + (data.compressed ? '&compressed=1' : '') + '&lng=' + window.language,
                data.file, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('storage'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        getFile(id, callback) {
            axios.get(axios.defaults.storageApiUrl + 'file?base64=true&filter={"id":' + id + '}&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('storage'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        deleteFile(id, callback) {
            axios.delete(axios.defaults.storageApiUrl + 'file?id=' + id + '&lng=' + window.language, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: Utils.getAuthorization('storage'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
        convertImageHeicToPng(file, callback) {
            const formData = new FormData()
            formData.append('file', file)
            axios.post(axios.defaults.storageApiUrl + 'file/convert/heic?lng=' + window.language,
                formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'X-Data-Type': 'image/heic',
                    Authorization: Utils.getAuthorization('storage'),
                },
            }).then((response) => {
                Utils.processResponse(response, callback)
            }).catch((response) => {
                Utils.processResponse(response, callback)
            })
        },
    },
}
